<script>
	const { fireEvent, events } = require('utilities/analyticsUtilities');
	const logger = require('utilities/logger');

	const { VOCAB_WIDGET_OPEN, VOCAB_WIDGET_CLOSE } = events;
	const uaParser = new (require('ua-parser-js'))();

	export default {
		components: {
			'vocab-popup': require('./vocab-popup.vue').default
		},
		data() {
			const device = uaParser.getDevice();
			const isIpadOS = uaParser.getOS().name === 'Mac OS' && navigator.maxTouchPoints > 0;
			const isMobile = isIpadOS || device.type === 'mobile' || device.type === 'tablet';
			return {
				popupSenseId: null,
				popupOccurrenceId: null,
				isMobile
			};
		},
		props: {
			isTeacher: {
				default: false,
				type: Boolean
			},
			article: {
				required: true
			},
			eventData: {
				required: false,
				default: function () {
					return {
						parentPid: undefined,
						assignmentId: undefined,
						loc: undefined
					};
				}
			}
		},
		watch: {
			article: {
				immediate: true,
				handler(article) {
					this.popupSenseId = null;
					this.popupOccurrenceId = null;
				}
			}
		},
		computed: {
			senseIds() {
				return Object.keys(this.article.vocab.support.senses);
			}
		},
		methods: {
			handleVocabularyClicks(ev) {
				let el = ev.target;
				if (!el || !el.hasAttribute) {
					return;
				}

				// if vocab is highlighted by student we may get an x-marker inside our span
				// or its conceivable we may click some other element inside a vocab word
				// trace up the DOM to what looks like a vocab word if we can
				while (!el.hasAttribute('data-vocab-sense-id') && el.parentNode && el.parentNode.hasAttribute) {
					el = el.parentNode;
				}

				if (el.hasAttribute('data-vocab-sense-id')) {
					const senseId = el.getAttribute('data-vocab-sense-id');
					let word = null;
					try {
						// these long paths of object refs might be missing, so catch that
						word = this.article.vocab.support.senses[senseId].word;
						const occurrenceId = el.getAttribute('data-vocab-occurrence-id');

						// grab all this event info into a constant since it could change
						// before the modal is closed (1000 to 1 but could happen)
						const { parentPid, assignmentId: aid, loc } = this.eventData;
						const vocabEventInfo = {
							parentPid,
							pid: this.article.uuid,
							aid,
							w: word,
							senseId: parseInt(senseId),
							loc
						};
						fireEvent(VOCAB_WIDGET_OPEN, vocabEventInfo);
						this.popupSenseId = senseId;
						this.popupOccurrenceId = occurrenceId;
						this.$refs.popup.open(el, `Definition of ${word}`);

						const unwatch = this.$watch('popupSenseId', () => {
							fireEvent(VOCAB_WIDGET_CLOSE, vocabEventInfo);
							unwatch();
						});
					} catch (err) {
						logger.info('vocab for sense ID', senseId, 'not found');
					}
				}
			}
		}
	};
</script>
<template>
	<div
		@click="handleVocabularyClicks"
		class="vocab-popup-content-wrapper vocab-popup-enabled">
		<vocab-popup
			ref="popup"
			@close="popupSenseId = null"
			:article="article"
			:event-data="eventData"
			:sense-id="popupSenseId"
			:occurrence-id="popupOccurrenceId"></vocab-popup>
		<slot></slot>
	</div>
</template>
